<template>
  <div class="w-full">
    <div
      class="flex items-start pl-10 w-full m-10 cursor-pointer"
      @click="goBack"
      test-id="goBackButton"
    >
      <logo-icon />
    </div>
    <div
      style="min-height: 80vh"
      class="flex flex-col items-center justify-center"
    >
      <system-error-image />
      <span class="font-bold text-base"> SYSTEM ERROR </span>
      <span>Sorry we ran in to an error </span>
      <span class=""> Please contact support and report </span>
      <span class="font-bold text-base">
        ERROR: {{ errorId ? errorId : '-' }}
      </span>
      <div
        @click="contactSupport"
        class="bg-primary px-12 py-3 cursor-pointer text-white text-sm p-2 rounded-lg mt-8"
        to="login"
        test-id="contactSupportButton"
      >
        Contact Support
      </div>
    </div>
  </div>
</template>

<script>
import app from '@/mixins/app.js'
export default {
  name: 'SystemError',
  mixins: [app],
  props: {},
  methods: {
    goBack () {
      this.$router.push('dashboard')
    },
    contactSupport () {
      window.open(
        this.tenantIsTorus
          ? 'mailto:hello@torusmara.com'
          : 'https://ovalfi.atlassian.net/servicedesk/customer/portal/'
      )
    }
  },
  components: {
    SystemErrorImage: () => import('@/assets/images/SystemErrorImage.vue'),
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  computed: {
    errorId () {
      return this.$store.state.common.errorId
    }
  }
}
</script>
